import { AppText, Button, Row } from '@streem/ui-react';

export const FailedToSendNoteToastContent = ({
    tryAgainHandler,
}: {
    tryAgainHandler: () => Promise<void>;
}): JSX.Element => {
    return (
        <Row alignItems="center">
            <AppText as="p" style={{ flexShrink: 0 }} data-testid="note-failed-to-send-message">
                Note Failed To Send.
            </AppText>
            <Button
                fontColor="azure"
                variant="transparent"
                onClick={tryAgainHandler}
                data-testid="note-failed-to-retry-button"
            >
                <span style={{ textDecoration: 'underline' }}>Try Again</span>
            </Button>
        </Row>
    );
};
